import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MapDetailService } from '../../../services/map-detail.service';

interface stopList {
  name:string,
  state:string,
  detail:string
}
interface NhptTrain {
  dire:string;
  trainNo: string;
  trainType: string;
  trainLink: string;
  startStop:string;
  endStop:string;
  nextStop:string;
  detail:string;
  state:string;
  stopList: stopList[];
}

@Component({
  selector: 'nhpt-traffic',
  standalone: true,
  template:`
  <div class="detail collapse {{ state }}" id="nhpt">
    <div class="card card-body">
      <a (click)="close()" role="button" aria-expanded="false" aria-controls="nhpt" class="bt-close">
        <span aria-hidden="true" class="close">×</span>
      </a>
      <div class="site-tt">站點資訊</div>

      @if(ifRoute){
      <div class="btn-back">
        <a (click)="back()" role="button">回上頁</a>
        <a target="_blank" [href]='NhptRoute.trainLink'>{{ NhptRoute.trainType }}</a>
        <a [href]='"https://www.taiwanbus.tw/eBUSPage/json/TMSQuery.aspx?routedata=" + NhptRoute.trainNo  + "&app=true"' target="_blank">票價時刻表</a>
      </div>
      <ul class="box bus">
        <li class="titbox">
        <div class="m-title"><img src="/static/images/svg/map_w_nhpt.svg" alt=""><p>{{ NhptRoute.trainType }} {{ NhptRoute.trainNo }} ( {{ NhptRoute.startStop }} → {{ NhptRoute.endStop }} )</p></div>
          <div class="s-title"><a (click)="getTrain()" role="button"><img src="/static/images/svg/ic_reset.svg" alt=""></a></div>
        </li>
        @for (stop of NhptRoute.stopList; track $index) {
          <li class="timelist">
            <p class="t-number">{{stop.name}}</p>
            <div class="time">
              <span class="arrow"></span>
              <p class="next" [class.d-none]='stop.detail == "無"'>{{stop.detail}}</p>
              <span class="next" [class.d-none]='stop.state == ""'>{{stop.state}}</span>
            </div>
          </li>
        }
      </ul>
      }
      @if(!ifRoute){
      <div class="ic_tit">
        <div><div class="icon"><img src="/static/images/svg/map_w_nhpt.svg" alt=""></div>{{ name }}</div>
        <a (click)="getTrain()" role="button"><img src="/static/images/svg/ic_reset_bk.svg" alt=""></a>
	    </div>

      <ul class="nav nav-tabs" id="myTab1" role="tablist">
        <li class="nav-item">
          <a (click)="getTrain()" class="nav-link active" id="north-tab1" data-toggle="tab" href="#north1" role="tab" aria-controls="north" aria-selected="true">北上</a>
        </li>
        <li class="nav-item">
          <a (click)="getTrain()" class="nav-link" id="south-tab1" data-toggle="tab" href="#south1" role="tab" aria-controls="south" aria-selected="false">南下</a>
        </li>
      </ul>



      <div class="tab-content" id="myTabContent1">
        <div class="tab-pane fade show active" id="north1" role="tabpanel" aria-labelledby="north-tab">
          <ul class="box mrt">
            <li class="titbox">
              <div class="m-title"><p>北上列車</p></div>
            </li>
            @for (Nouthtrain of NouthtrainList; track $index) {
              <li (click)="getRoute(Nouthtrain)" class="timelist">
              <p class="subtit">{{ Nouthtrain.trainType }} {{ Nouthtrain.trainNo }} ( {{ Nouthtrain.startStop }} → {{ Nouthtrain.endStop }} )</p>
              <div class="time">
                <p class="in">
                  <strong [class.d-none]='Nouthtrain.detail == "無"'>預計 {{ Nouthtrain.detail }} 出發</strong>
                  <span class="delay" [class.d-none]='Nouthtrain.state == ""'>{{Nouthtrain.state}}</span>
                </p>

                <div class="d-flex"><span class="arrow"></span><p class="next">{{ Nouthtrain.nextStop }}</p></div>
              </div>
            </li>
          }
          </ul>
        </div>

        <div class="tab-pane fade" id="south1" role="tabpanel" aria-labelledby="south-tab">
          <ul class="box mrt">
            <li class="titbox">
              <div class="m-title"><p>南下列車</p></div>
            </li>
            @for (Southtrain of SouthtrainList; track $index) {
              <li (click)="getRoute(Southtrain)" class="timelist">
              <p class="subtit">{{ Southtrain.trainType }} {{ Southtrain.trainNo }} ( {{ Southtrain.startStop }} → {{ Southtrain.endStop }} )</p>
              <div class="time">
                <p class="in">
                  <strong [class.d-none]='Southtrain.detail == "無"'>預計 {{ Southtrain.detail }} 出發</strong>
                  <span class="delay" [class.d-none]='Southtrain.state == ""'>{{ Southtrain.state }}</span>
                </p>
                <div class="d-flex"><span class="arrow"></span><p class="next">{{ Southtrain.nextStop }}</p></div>
              </div>
            </li>
          }
          </ul>
        </div>
      </div>
      }
    </div>
  </div>
  `
})

export class NhptTrafficComponent {

  // [ClienteService] 定義服務
  constructor(private mapDetailService: MapDetailService) {
  }

  @Input() name: string = "";
  @Input() stationId: string = "";
  @Output() callBack =  new EventEmitter<void>();
  state:string =""
  ifRoute: boolean = false;
  NouthtrainList:NhptTrain[] = []
  SouthtrainList:NhptTrain[] = []
  NhptRoute:NhptTrain

  ngOnChanges(){
    this.state = "show";
    if(this.state = "show") {
      this.getTrain();
      this.ifRoute = false;
    }
  }
  close(){
    this.callBack.emit();
  }

  getTrain() {

    this.mapDetailService.getNhpt(this.stationId).subscribe((NhptObject:any) => {
      this.NouthtrainList = [];

      for(let nhpt of NhptObject.north){
        this.NouthtrainList.push({
          trainNo:        nhpt.trainNo,
          detail:         nhpt.detail,
          trainType:      nhpt.trainType,
          trainLink:      nhpt.trainLink,
          startStop:      nhpt.startStop,
          endStop:        nhpt.endStop,
          nextStop:       nhpt.nextStop,
          state:          nhpt.state,
          stopList:       nhpt.stopList,
          dire:           "0"

        })

        if(this.NhptRoute?.dire === "0" && nhpt.name === this.NhptRoute?.trainNo){
            this.NhptRoute = {
            trainNo:        nhpt.trainNo,
            detail:         nhpt.detail,
            trainType:      nhpt.trainType,
            trainLink:      nhpt.trainLink,
            startStop:      nhpt.startStop,
            endStop:        nhpt.endStop,
            nextStop:       nhpt.nextStop,
            state:          nhpt.state,
            stopList:       nhpt.stopList,
            dire:           "0"
          };
        }
      }

      this.SouthtrainList = [];
      for(let nhpt of NhptObject.south){
        this.SouthtrainList.push({
          trainNo:        nhpt.trainNo,
          detail:         nhpt.detail,
          trainType:      nhpt.trainType,
          trainLink:      nhpt.trainLink,
          startStop:      nhpt.startStop,
          endStop:        nhpt.endStop,
          nextStop:       nhpt.nextStop,
          state:          nhpt.state,
          stopList:       nhpt.stopList,
          dire:           "1"
        });

        if(this.NhptRoute?.dire === "1" && nhpt.name === this.NhptRoute?.trainNo){
            this.NhptRoute = {
              trainNo:        nhpt.trainNo,
              detail:         nhpt.detail,
              trainType:      nhpt.trainType,
              trainLink:      nhpt.trainLink,
              startStop:      nhpt.startStop,
              endStop:        nhpt.endStop,
              nextStop:       nhpt.nextStop,
              state:          nhpt.state,
              stopList:       nhpt.stopList,
              dire:           "1"
          };
        }
      }
    });
  }

  getRoute(nhptTrain:NhptTrain){
    this.ifRoute = true;
    this.NhptRoute = nhptTrain;
  }


  back(){
    this.ifRoute = false;
  }



}
